import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SalaryComponent } from './salary/salary.component';
import { SelectModule } from 'primeng/select';
import { TranslateModule } from '@ngx-translate/core';
import { WorkExperienceComponent } from './work-experience/work-experience.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { EmploymentFormComponent } from './work-from-home/employment-form.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    SalaryComponent,
    WorkExperienceComponent,
    EmploymentFormComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    TranslateModule,
    MatTooltipModule
],
  exports: [SalaryComponent, WorkExperienceComponent, EmploymentFormComponent],
})
export class FiltersModule {}
